import { AffiliateRequest, CreateAffiliateRequestType } from '@monorepo/types';
import { useStore } from '@hub/helpers/use-store';
import { QueryConfigKeys } from '@hub/utils/react-query/query-config';
import {
  activateAffiliateSplit,
  createAffiliateRequest,
  registerAsAffiliate,
  revertAffiliateSplit,
} from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
// import { Application, UserPayload } from '@monorepo/types';
// import { Application, UserPayload } from '@monorepo/client-types';
// import {
//   AppCookieType,
//   deleteAppCookie,
//   deleteLeadDynoData,
//   getAppCookie,
// } from '@monorepo/client-common';
// import { getEnv } from '@admin/helpers/getters.store';

export const useRegisterAsAffiliate = () => {
  const {
    dataStore: { userStore },
  } = useStore();

  return useMutation({
    mutationFn: registerAsAffiliate,
    onSuccess: (affiliateId) => {
      if (affiliateId) {
        userStore.setCurrentUser({
          ...userStore.currentUser,
          affiliateId: affiliateId.toString(),
        });
      }
    },
  });
};

export const useCreateAffiliateRequest = () => {
  return useMutation<AffiliateRequest, Error, CreateAffiliateRequestType>({
    mutationFn: createAffiliateRequest,
  });
};

export const useActivateAffiliateSplit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activateAffiliateSplit,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS[QueryConfigKeys.AFFILIATES].DASHBOARD,
      });
    },
  });
};

export const useRevertAffiliateSplit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: revertAffiliateSplit,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS[QueryConfigKeys.AFFILIATES].DASHBOARD,
      });
    },
  });
};

// export const useRecordLead = () => {
//   return useMutation<
//     boolean,
//     Error,
//     Omit<UserPayload, 'password' | 'country' | 'recaptcha'>
//   >({
//     mutationFn: async (params) => {
//       const project: Application =
//         import.meta.env.VITE_PROJECT || Application.TTP;

//       const {
//         apiFactory: { affiliationService },
//         envConfig: { domain_name: domain },
//       } = getEnv();

//       const oldAffiliateCode = getAppCookie(
//         AppCookieType.OldAffiliation,
//         project
//       );
//       let isOldAffiliationRecorded = false;

//       if (oldAffiliateCode) {
//         isOldAffiliationRecorded =
//           await affiliationService.recordLeadByOldAffiliation({
//             ...params,
//             oldAffiliationCode: oldAffiliateCode,
//             url: window.location.href,
//           });

//         if (isOldAffiliationRecorded) {
//           window.LeadDyno.devTools.reset();
//           deleteLeadDynoData(domain);
//         }
//         deleteAppCookie(AppCookieType.OldAffiliation, domain, project);
//       }

//       if (!oldAffiliateCode || !isOldAffiliationRecorded) {
//         window.LeadDyno.recordLead(params.email, {
//           first_name: params.firstName,
//           last_name: params.lastName,
//         });
//       }

//       return isOldAffiliationRecorded;
//     },
//   });
// };
